/*https://github.com/harttle/liquidjs/wiki*/

import Liquid from 'liquidjs';
// import { add_attribute } from 'svelte/internal';
// import { getIndexByAttr } from './ListExtensions';

let engine = new Liquid.Liquid();
engine.registerFilter('ing', v => v + 'ing');
engine.registerFilter('lowerCase', v => v.toLocaleLowerCase());

engine.registerFilter('lowerContextSensitive', str => {
    const numUpper = str.length - str.replace(/[A-Z]/g, '').length;
    if (numUpper > 1) return str;
    else return str.charAt(0).toLocaleLowerCase() + str.slice(1)
});


export async function getDemoCopy(scope) {


    return new Promise((resolve, reject) => {
        const templates = ["Struggling to {{gain|lowerContextSensitive}}? Meet {{feature|lowerContextSensitive}}, made for {{persona|lowerContextSensitive}}.", "The solution to {{pain|lowerContextSensitive}}: {{feature|lowerContextSensitive}} for {{persona|lowerContextSensitive}}.", "Tired of {{pain|lowerContextSensitive}}? Try {{feature|lowerContextSensitive}} and {{gain|lowerContextSensitive}}."
        ]
        let rVal = []

        for (let i = 0; templates.length > i; i++) {
            let term = templates[i];
            engine.parseAndRender(term, scope)
                .then((res) => { rVal.push(res) });
        }
        resolve(rVal);
    });
}